import React from "react";
import { Lock, Gem, UserRound, ShieldCheck } from "lucide-react";
import { Separator } from "@/components/ui/separator";
const trustBadges = [{
  id: 1,
  title: "Absolutní Diskrétnost",
  description: "Vaše soukromí je naší nejvyšší prioritou v každém okamžiku.",
  icon: Lock
}, {
  id: 2,
  title: "Prémiová Čistota",
  description: "Dodržujeme nejpřísnější hygienické standardy pro váš komfort.",
  icon: Gem
}, {
  id: 3,
  title: "Osobní Přístup",
  description: "Každá návštěva je přizpůsobena vašim individuálním přáním.",
  icon: UserRound
}, {
  id: 4,
  title: "Bezpečné Prostředí",
  description: "Certifikované zázemí pro ničím nerušený smyslový zážitek.",
  icon: ShieldCheck
}];
export default function GarantiaDeCalidad() {
  return <section data-section-id="223310" id="záruka-diskrétnosti" className="relative bg-muted w-full text-foreground">
      <Separator className="absolute top-0 w-full bg-border/20" />
      
      <div className="container mx-auto px-4 py-8 md:py-10">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-6">
          {trustBadges.map((badge, i) => {
          const Icon = badge.icon;
          return <div key={badge.id} data-index={i} className="flex flex-col items-center text-center space-y-3 group">
                <div className="text-primary transition-transform duration-500 group-hover:scale-110">
                  <Icon className="size-10" strokeWidth={1} />
                </div>
                <div className="space-y-1">
                  <h3 className="text-sm font-bold font-default text-foreground tracking-widest uppercase">
                    {badge.title}
                  </h3>
                  <p className="text-xs text-foreground/80 font-default max-w-[200px] mx-auto leading-relaxed">
                    {badge.description}
                  </p>
                </div>
              </div>;
        })}
        </div>
      </div>

      <Separator className="absolute bottom-0 w-full bg-border/20" />
    </section>;
}